import moment from "moment-timezone";
import DataTable from "react-data-table-component";
import { useHistory } from "react-router-dom";

const SocialProofList = ({
  socialProofData,
  handleAttachmentClick,
  setOpen,
  setActiveId,
}) => {
  const columnDefs = [
    {
      name: "Title",
      selector: (row) => row?.title || row?.name,
      sortable: true,
      maxWidth: "300px",
    },
    {
      name: "Date",
      selector: (row) => moment(row?.createdAt).format("DD/MM/YYYY HH:mm"),
      sortable: true,
      maxWidth: "auto",
    },
    {
      name: "View Attachment",
      cell: (row) =>
        row?.video ? (
          <button
            className="btn btn-sm btn-primary"
            onClick={() => handleAttachmentClick(row?.video)}
          >
            View
          </button>
        ) : (
          "No Attachment"
        ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      minWidth: "150px",
    },

    {
      name: "Actions",
      cell: (row) => (
        <ActionButton
          row={row}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      minWidth: "150px",
    },
  ];

  const history = useHistory();

  const handleEdit = (id) => {
    history.push(`/create-social-proof?id=${id}`);
  };

  const handleDelete = (id) => {
    setActiveId(id);
    setOpen(true);
  };

  return (
    <div className="table-responsive">
      <DataTable
        data={socialProofData || []}
        columns={columnDefs}
        pagination
        selectableRows={false}
        onSelectedRowsChange={(e) => console.log("Selected Rows:", e)}
      />
    </div>
  );
};

export default SocialProofList;

const ActionButton = ({ row, handleDelete, handleEdit }) => {
  return (
    <div className="action-btn">
      {
        <span>
          <i
            onClick={() => handleDelete(row._id)}
            className="fa fa-trash"
            style={{
              width: 35,
              fontSize: 20,
              padding: 11,
              color: "#e4566e",
            }}
          ></i>
        </span>
      }
      {
        <span>
          <i
            onClick={() => handleEdit(row._id)}
            className="fa fa-pencil"
            style={{
              width: 35,
              fontSize: 20,
              padding: 11,
              color: "rgb(40, 167, 69)",
            }}
          ></i>
        </span>
      }
    </div>
  );
};
